module.exports={
    "两次输入的密码必须一致": "Mật khẩu nhập không trùng khớp",
    "取消": "Huỷ",
    "如验证出现问题，请点击": "Nếu chứng thực không được, hãy bấm tại đây",
    "如验证出现问题，请联系orcalivecs@asiainnovations.com": "Nếu kiểm tra mà phát hiện vấn đề, hãy liên hệ orcalivecs@asiainnovations.com",
    "如验证出现问题，请联系upcs@asiainnovations.com": "Nếu kiểm tra mà phát hiện vấn đề, hãy liên hệ upcs@asiainnovations.com",
    "密码修改成功": "Đổi mật khẩu thành công",
    "密码格式错误": "Định dạng mật khẩu không đúng",
    "密码由6-20位由数字和字母组成": "Mật khẩu từ 6-20 ký tự gồm chữ và số",
    "恭喜您密码重置成功": "Chúc mừng bạn đổi mật khẩu thành công",
    "恭喜您已成功激活帐户": "Chúc mừng bạn kích hoạt tài khoản thành công",
    "知道了": "OK",
    "确认修改": "Xác nhận thay đổi",
    "网络连接有误, 请稍后再试": "Lỗi mạng, thử lại sau",
    "联系客服": "Liên hệ CS",
    "请再次输入密码": "Nhập lại mật khẩu",
    "请返回UpVoice中重新进行邮箱验证": "Về UpVoice chứng thực email",
    "请返回Up直播中重新进行邮箱验证": "Về Uplive chứng thực email",
    "请重新设定登录密码": "Thiết lập lại mật khẩu đăng nhập",
    "请重新设置密码": "Thiết lập lại mật khẩu",
    "赶快返回UpVoice中与全球潮人互动吧": "Trở về UpVoice và tiếp tục giao lưu với idol nào!",
    "赶快返回Up直播中与全球潮人互动吧！": "Trở về Uplive và tiếp tục giao lưu với idol nào!",
    "重置密码失败": "Thiết lập mật mã thất bại",
    "验证失败": "Chứng thực thất bại",
    "验证成功": "Chứng thực thành công"
};


// WEBPACK FOOTER //
// ./js/lang/vivn.js